import * as sitesActions from './actions'
import * as actionTypes from './action-types'
import reducer from './reducers'
import Site from './site'
import * as selectors from './selectors'


import { getAuthToken } from 'modules/auth'
import { SITE_INFO_API } from 'config'

const getSiteInfo = (url, auth) => {
  let requestUrl = SITE_INFO_API + '?url=' + url
  if (typeof auth === 'object') {
    requestUrl += `&auth=${auth.user}:${auth.pass}`
  }
  return getAuthToken()
    .then(idToken => {
      return fetch(requestUrl, {
        mode: 'cors',
        method: 'GET',
        headers: new Headers({
          'Authorization': 'Bearer ' + idToken,
          'Content-Type': 'application/json'
        })
      })
    })
    .then(response => response.json())
}

export { sitesActions, actionTypes, reducer, selectors, Site, getSiteInfo }



// WEBPACK FOOTER //
// ./src/modules/sites/index.js